<template>
  <div>
    <div class="vx-col w-full">
      <ul class="heading-ul mb-5">
        <li>
          <router-link :to="backRoute" class="vx-row">
            <feather-icon icon="ArrowLeftIcon" svgClasses="text-dark" />
            <h4>{{ $t("setup.label.AddOrEditDiscount") }}</h4>
          </router-link>
        </li>
      </ul>
    </div>
    <div class="vx-row less-padding">
      <vx-card>
        <div class="vx-col w-full less-padding">
          <div class="vx-row border-left heading">
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("setup.label.PlanCode") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              {{ $t("setup.label.ProductCode") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              {{ $t("setup.label.ChargeCode") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              {{ $t("setup.label.ChargeOwner") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              {{ $t("setup.label.DiscountCode") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              {{ $t("setup.label.GLID") }}
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              {{ $t("setup.label.Actions") }}
            </div>
          </div>
          <!-- <pre>{{ editPriceArray }}</pre>
          <pre>{{ productPriceList }}</pre> -->
          <div
            class="vx-row pt-2 pb-2 border-left"
            :key="index"
            :data="priceEl"
            v-for="(priceEl, index) in productPriceList"
          >
            <div class="vx-col w-full sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12">
              <vs-input
                class="w-full mb-2 font-semibold padding-zero"
                :placeholder="$t('setup.label.Enter_Plan_Description')"
                v-model="productPriceList[index].planCode"
                readonly
              />
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              <v-select
                v-if="$route.query.type == 'NONE'"
                label="productDescription"
                v-model="productPriceList[index].productId"
                :options="productCodeOption"
                :reduce="(obj) => obj.productId"
                :placeholder="$t('placeholder.label.SelectOne')"
                :disabled="true"
              >
                <template v-slot:option="option">{{
                  option.productDescription
                }}</template>
              </v-select>
              <v-select
                v-else
                label="productDescription"
                v-model="productPriceList[index].productId"
                :options="productCodeOption"
                :reduce="(obj) => obj.id"
                :placeholder="$t('placeholder.label.SelectOne')"
                :disabled="true"
              >
                <template v-slot:option="option">{{
                  option.productDescription
                }}</template>
              </v-select>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              <v-select
                label="chargeDescription"
                v-model="productPriceList[index].chargeCode"
                :options="priceWithTemplate.chargeData"
                :reduce="(obj) => obj.chargeCode"
                :placeholder="$t('placeholder.label.SelectOne')"
                :disabled="true"
              >
                <template v-slot:option="option">{{
                  option.chargeDescription
                }}</template>
              </v-select>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              <v-select
                label="name"
                v-model="productPriceList[index].chargeOwner"
                :options="chargeOwners"
                :reduce="(obj) => obj.value"
                :placeholder="$t('placeholder.label.SelectOne')"
                :disabled="true"
              >
                <template v-slot:option="option">{{ option.name }}</template>
              </v-select>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              <v-select
                label="code"
                v-model="productPriceList[index].discountId"
                :options="discountCodeData.pageItems"
                :reduce="(obj) => obj.id"
                :placeholder="$t('placeholder.label.SelectOne')"
              >
                <template v-slot:option="option">{{ option.code }}</template>
              </v-select>
            </div>
            <div class="vx-col w-full sm:w-1/2 md:w-1/6 lg:w-1/6 xl:w-1/6">
              <v-select
                label="mCodeValue"
                v-model="productPriceList[index].glId"
                :options="priceWithTemplate.glRealatedData"
                :placeholder="$t('placeholder.label.SelectOne')"
                :reduce="(obj) => obj.id"
                :disabled="true"
              >
                <template v-slot:option="option">{{
                  option.mCodeValue
                }}</template>
              </v-select>
            </div>
            <div
              class="vx-col w-full flex sm:w-1/2 md:w-1/12 lg:w-1/12 xl:w-1/12"
            >
              <vs-button
                icon-pack="feather"
                icon="icon-plus"
                @click="addDiscount(productPriceList[index].id, index)"
                color="success"
                size="small"
                >{{ $t("setup.label.Update") }}</vs-button
              >
            </div>
          </div>
        </div>
      </vx-card>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";
import vSelect from "vue-select";
export default {
  components: {
    "v-select": vSelect,
  },
  data() {
    return {
      roundingTypes: [
        "RoundingUp",
        "RoundingDown",
        "RoundingHalf",
        "RoundingNearest",
      ],
      chargeOwners: [
        { name: "Self", value: "self" },
        { name: "Parent", value: "parent" },
      ],
      editPriceArray: [],
      productTypeId: "",
    };
  },
  computed: {
    ...mapState({
      priceWithTemplate: (state) => state.planPrice.priceWithTemplate,
      productDiscounts: (state) => state.planPrice.productDiscounts,
      discountCodeData: (state) => state.planPrice.discountCodeData,
    }),

    backRoute() {
      if (Object.keys(this.$route.query).length) {
        return { name: "View Plan", params: { id: this.$route.params.id } };
      } else return { name: "Plan Pricing" };
    },
    productCodeOption() {
      let arr = [];
      if (this.$route.query.type == "NONE") {
        this.priceWithTemplate.pricingData.forEach((el) => {
          if (el.productId == 0)
            arr.push({
              productId: el.productId,
              productDescription: "NONE",
            });
        });
        return arr;
      } else return this.priceWithTemplate.serviceData;
    },
    productPriceList() {
      let arr = [];
      if (
        this.$route.query &&
        this.$route.query.type &&
        Object.keys(this.$route.query.type).length &&
        this.$route.query.type != "NONE"
      ) {
        this.editPriceArray.map((el) => {
          if (el.productCode == this.$route.query.type) {
            arr.push(el);
          }
        });
      } else {
        this.editPriceArray.map((el) => {
          if (el.productId == 0) {
            arr.push(el);
          }
        });
      }
      return arr;
    },
  },
  methods: {
    async addDiscount(id, index) {
      let payload = {
        chargeOwner: this.editPriceArray[index].chargeOwner,
        planCode: this.editPriceArray[index].planCode,
        isPrepaid: this.editPriceArray[index].isPrepaid,
        productId: this.productPriceList[index].productId,
        discountId: this.editPriceArray[index].discountId,
        chargeCode: this.editPriceArray[index].chargeCode,
        currencyId: this.editPriceArray[index].currencyId,
        duration: this.editPriceArray[index].duration,
        price: this.editPriceArray[index].price.toString(),
        chargevariant: this.editPriceArray[index].chargevariant,
        locale: "en",
        type: "D",
      };
      try {
        await this.$store.dispatch("planPrice/updatePriceAction", {
          id: id,
          data: payload,
        });
        this.$swal({
          title: "Success",
          icon: "success",
          text: "Discout added/Edited Successfully!",
          type: "success",
        });
        this.$router.push({ name: "View Plan" });
        this.getPriceWithTemplate();
      } catch (error) {
        this.$toasted.error(error.message);
      }
    },
    async getProductDiscountTemplate() {
      try {
        await this.$store.dispatch("planPrice/fetchProductDiscountTemplate");
      } catch (error) {
        this.$toasted.error(error.message);
      }
    },
    async getDiscountCodes() {
      try {
        await this.$store.dispatch("planPrice/setDiscountCodeData");
        this.discountCodeOpt = this.discountCodeData;
      } catch (error) {
        throw Error(
          error.message.errors[0].defaultUserMessage ||
            `Api failed with status code: ${error.message.httpStatusCode}`
        );
      }
    },
    async getPriceWithTemplate() {
      try {
        let template = await this.$store.dispatch(
          "planPrice/setPriceWithTemplate",
          this.$route.params.id
        );

        this.editPriceArray = this.priceWithTemplate.pricingData.map((el) => {
          return { ...el };
        });
        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.priceRegionData.forEach((x) => {
            if (x.priceregion == el.priceregion) el.priceregion = x.id;
          });
        });

        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.chargeData.forEach((x) => {
            if (x.chargeDescription == el.chargeCode)
              el.chargeCode = x.chargeCode;
          });
        });

        this.editPriceArray.forEach((el) => {
          this.priceWithTemplate.chargevariant.forEach((x) => {
            if (x.value == el.chargeVariant) el.chargevariant = x.id;
            delete el.chargeVariant;
          });
        });
      } catch (e) {
        this.$toasted.error(e.message);
      }
    },
  },
  async mounted() {
    await this.getPriceWithTemplate();
    await this.getProductDiscountTemplate();
    await this.getDiscountCodes();
  },
};
</script>

<style scoped>
.padding-zero {
  padding-top: 0px;
}
::v-deep .vs__selected-options {
  overflow: hidden;
  width: 100px;
  font-size: 12px;
  display: block;
}
.price-table >>> .vs-input--input.normal {
  width: 80px;
  font-size: 12px;
}
::v-deep .vs--searchable .vs__dropdown-toggle {
  height: 40px;
}
::v-deep .vs-table-text {
  display: block;
}
::v-deep .vs__selected {
  text-wrap: nowrap;
}
.less-padding .vx-row > .vx-col {
  padding: 0 4px;
}
::v-deep .vs-table--not-data {
  display: none;
}
</style>
<style lang="scss" scoped>
.w-13 {
  width: 8.5%;
  padding: 0 4px;
  max-width: 90px;
  &:last-child {
    width: 4%;
  }
}
.border-left {
  border-bottom: 1px solid rgba(var(--vs-primary), 0.3);
  div {
    &:not(:first-child) {
      border-left: 1px solid rgba(var(--vs-primary), 0.3);
    }
    &:nth-child(6) {
      border-right: 1px solid rgba(var(--vs-primary), 0.3);
    }
  }
}
.heading {
  font-weight: 600;
  font-size: 0.9rem;
  div {
    padding: 0.5rem 5px !important;
  }
}
.margin-bottom {
  width: 100%;
  border-bottom: 1px solid #777;
  margin-bottom: 20px;
}
</style>
